import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

const getClientAndTagsGQL = clientId => {
  const query = `
    query ($clientId: ID!){
        clients(clientId: $clientId){
           nodes{
                name
                status
                logo
                code
                countryId
                isSelfServeEnabled
                apiAccessEnabled
                industry
                industryGroup
                isTaxExemptionEnabled
                isAffiliate
                isSkipCheckoutEnabled
                sftpEnabled
                addressVerificationEnabled
                addressVerificationDailyBudget
                addressVerificationMonthlyBudget
                createdBy
                tags{
                    id
                    value
                    type
                    tagLinkId
                    }
           }
        }
       getTags(type: CLIENT){
            edges {
                 node {
                    id
                    value
                    type
                 }
            }
       }
       getClientTaxExemptionByState(clientId: $clientId){
                   id
                   clientId
                   stateCode
                   name
                   deletedAt
                   uploadedBy
                   url
                   createdAt
       }
    }
  `
  const params = { clientId }
  return callAuthorizedGraphQLEndpoint(query, params)
}

const createClientTaxExemptionByState = async ({ clientId, state, file }) => {
  const query = `mutation createClientTaxExemptionByState(
    $input: CreateClientTaxExemptionByStateInput!
  ) {
    createClientTaxExemptionByState(
      input: $input
    ) { 
      success
    }
  }`

  const res = await callAuthorizedGraphQLEndpoint(query, {
    input: {
      clientId,
      state,
      file,
    },
  })

  const {
    data: { createClientTaxExemptionByState },
  } = await res.json()
  return createClientTaxExemptionByState
}

const deleteClientTaxExemptionByState = async id => {
  const query = `mutation deleteClientTaxExemptionByState(
    $input: DeleteClientTaxExemptionByStateInput!
  ) {
    deleteClientTaxExemptionByState(
      input: $input
    ) { 
      success
    }
  }`

  const res = await callAuthorizedGraphQLEndpoint(query, {
    input: {
      id,
    },
  })

  const {
    data: { deleteClientTaxExemptionByState },
  } = await res.json()
  return deleteClientTaxExemptionByState
}

const getClientTaxExemptionByStateGQL = async clientId => {
  const query = `
    query ($clientId: ID!){
       getClientTaxExemptionByState(clientId: $clientId){
                   id
                   clientId
                   stateCode
                   name
                   deletedAt
                   uploadedBy
                   url
                   createdAt
       }
    }
  `

  const res = await callAuthorizedGraphQLEndpoint(query, { clientId })
  const {
    data: { getClientTaxExemptionByState },
  } = await res.json()

  return getClientTaxExemptionByState
}

export {
  getClientAndTagsGQL,
  createClientTaxExemptionByState,
  deleteClientTaxExemptionByState,
  getClientTaxExemptionByStateGQL,
}
